"use strict";
exports.__esModule = true;
exports.WIDGET_ADDITIONAL_PRODUCTS = void 0;
exports.WIDGET_ADDITIONAL_PRODUCTS = [
    'FLIGHTS',
    'TRANSFERS',
    'PACKAGES',
    'CANCELLATION_INSURANCES',
    'ACTIVITIES',
];
//# sourceMappingURL=widget-additional-products.constant.js.map